<template>
	<v-img
		height="100"
		:src="background"
		class="white--text"
		gradient="to bottom, rgba(11, 28, 61, .9), rgba(0,0,0,.4)"
	>
		<v-container class="px-4 py-10 container--box">
			<v-layout row wrap class="container--box">
				<v-flex xs12 sm6 md6>
					<v-btn-toggle dense group class="py-0 px-0 ml-n3">
						<v-btn text class="py-0 px-0">
							<a :href="socials.app_store" target="_blank">
								<v-img
									:src="app_store"
									max-width="200px"
								></v-img>
							</a>
						</v-btn>
						<v-btn text class="py-0 px-0"
							><a :href="socials.play_store" target="_blank">
								<v-img
									:src="play_store"
									max-width="160px"
								></v-img> </a
						></v-btn>
					</v-btn-toggle>
				</v-flex>
			</v-layout>
		</v-container>
	</v-img>
</template>
<script>
import { Link } from "@inertiajs/inertia-vue";
export default {
	props: ["background", "app_store", "play_store", "socials"],
	components: {
		Link,
	},
};
</script>
<style  scoped>
</style>